var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgScanner(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 7.3125C16.1925 7.3125 15.9375 7.0575 15.9375 6.75V5.25C15.9375 3.315 14.685 2.0625 12.75 2.0625H5.25C3.315 2.0625 2.0625 3.315 2.0625 5.25V6.75C2.0625 7.0575 1.8075 7.3125 1.5 7.3125C1.1925 7.3125 0.9375 7.0575 0.9375 6.75V5.25C0.9375 2.67 2.67 0.9375 5.25 0.9375H12.75C15.33 0.9375 17.0625 2.67 17.0625 5.25V6.75C17.0625 7.0575 16.8075 7.3125 16.5 7.3125Z",
    fill: "current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.75 17.0625H5.25C2.67 17.0625 0.9375 15.33 0.9375 12.75V11.25C0.9375 10.9425 1.1925 10.6875 1.5 10.6875C1.8075 10.6875 2.0625 10.9425 2.0625 11.25V12.75C2.0625 14.685 3.315 15.9375 5.25 15.9375H12.75C14.685 15.9375 15.9375 14.685 15.9375 12.75V11.25C15.9375 10.9425 16.1925 10.6875 16.5 10.6875C16.8075 10.6875 17.0625 10.9425 17.0625 11.25V12.75C17.0625 15.33 15.33 17.0625 12.75 17.0625Z",
    fill: "current"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 9.5625H1.5C1.1925 9.5625 0.9375 9.3075 0.9375 9C0.9375 8.6925 1.1925 8.4375 1.5 8.4375H16.5C16.8075 8.4375 17.0625 8.6925 17.0625 9C17.0625 9.3075 16.8075 9.5625 16.5 9.5625Z",
    fill: "current"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.375 6.75H5.625C5.415 6.75 5.25 6.585 5.25 6.375V4.875C5.25 4.2525 5.7525 3.75 6.375 3.75H11.625C12.2475 3.75 12.75 4.2525 12.75 4.875V6.375C12.75 6.585 12.585 6.75 12.375 6.75Z",
    fill: "current"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.375 11.25H5.625C5.415 11.25 5.25 11.415 5.25 11.625V13.125C5.25 13.7475 5.7525 14.25 6.375 14.25H11.625C12.24 14.25 12.75 13.7475 12.75 13.125V11.625C12.75 11.415 12.585 11.25 12.375 11.25Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScanner);
export default __webpack_public_path__ + "97120/static/media/Scanner.691d327d88acf5178cd5285ddac55179.svg";
export { ForwardRef as ReactComponent };